import { useContext } from "react"
import Contexto from "../../Contexts/Ble/Ctx"

const useBle=()=>{
    const ble = useContext(Contexto)
    return ble
}

export default useBle